export const isWebsiteValid = (url: string) => {
  const websiteRegex = new RegExp(/^(https?:\/\/)?(www\.)?[a-zA-Z0-9]+(\.[a-z]{2,}){1,3}(\/.*)?$/);
  return !!websiteRegex.exec(url)
}